import DeleteTemplateCallout from "~/areas/platformHub/DeleteTemplateCallout";
import type { MenuItem } from "~/components/OverflowMenu/OverflowMenu";
import { OverflowMenu, OverflowMenuItems } from "~/components/OverflowMenu/OverflowMenu";
interface TemplateOverflowMenuProps {
    templateName: string;
    templateTypeLabel: "process template" | "project template";
    onDelete: () => Promise<void>;
}
export function TemplateOverflowMenu({ templateName, templateTypeLabel, onDelete }: TemplateOverflowMenuProps) {
    const overFlowActions: Array<MenuItem | MenuItem[]> = [];
    overFlowActions.push(OverflowMenuItems.deleteItem("Delete", `Are you sure you want to delete this ${templateTypeLabel}?`, onDelete, <DeleteTemplateCallout templateName={templateName} templateTypeLabel={templateTypeLabel}/>));
    return <OverflowMenu menuItems={overFlowActions}/>;
}
